module.exports = __webpack_public_path__ + "static/media/league-with-back.8ee0c48f.svg";